import Cookies from "js-cookie";

const createDataView = async ({ commit, rootGetters, dispatch }, payload) => {
  commit("SET_CREATE_DATA_VIEW_LOADING", true);
  try {
    const customer = rootGetters["customer/CUSTOMER"];
    const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
    const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

    if (customer.customer_id === 0) {
      data.customer_id = selected_customer.customer_id;
    }

    const response = await window.axios.post(`/proxy/data-views?customer_id=${data.customer_id}`, data);
    if (response && response.data.dataView) {
      return response.data.dataView
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch("notifications/setError", error.message, { root: true });
  } finally {
    commit("SET_CREATE_DATA_VIEW_LOADING", false);
  }
};

export default createDataView;